<template>
	<div style="overflow: clip;">
		<header>
			<NavBar />
		</header>
		<main class="ptb-10">
			<div class="ellipse">
				<img src="/img/ellipse/ellipse_yellow_1.svg"
					alt="Ellipse 1" />
				<img src="/img/ellipse/ellipse_pink.svg"
					alt="Ellipse 2" />
				<img src="/img/ellipse/ellipse_turquoise.svg"
					alt="Ellipse 3" />
			</div>
			<div class="container">
				<slot />
			</div>
		</main>
		<Footer />
	</div>
</template>
